import React, { useState } from "react";
import { Row, Col, Image, Space, Button, Input, Dropdown, Menu } from "antd";
import whitePaper from "../../assets/websiteIcon/footer/white_paper.webp";
import havetoLogo from "../../assets/haveto.svg";
import twitterIcon from "../../assets/websiteIcon/footer/_twitter.svg";
import linkdinIcon from "../../assets/websiteIcon/footer/_linkdin.svg";
import telegramIcon from "../../assets/websiteIcon/footer/_telegram.svg";
import moment from "moment";
import { useAppDispatch } from "../../store/hooks";
import { subscriptionActions } from "../../store/subscription";
import whitePaperPdf from "../../assets/websiteIcon/footer/HaveTo_Token_Tokenomics_Whitepaper.pdf";
import { Link } from "react-router-dom";

const menu = (
  <Menu>
    <Menu.Item>
      <a target="_blank" rel="noopener noreferrer" href="https://t.me/+ymU6o-JesW4xYzM1">
        Developers
      </a>
    </Menu.Item>
    <Menu.Item>
      <a target="_blank" rel="noopener noreferrer" href="https://t.me/haveto_com">
        Community
      </a>
    </Menu.Item>
  </Menu>
);

const Footer = () => {
  const currentYear = moment().utc().format("YYYY");
  const [email, setemail] = useState("")
  const dispatch = useAppDispatch();
  function onSubscribe() {
    dispatch(subscriptionActions.createSubscription({
      email :email
    }));
  }

  const handleDownloadWhitePaper = () => {
    const link = document.createElement('a');
    link.href = whitePaperPdf;
    link.download = 'HaveTo_Token_Tokenomics_Whitepaper.pdf'; // What the file will be called when downloaded
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="footer">
        <div className="features">
          <div className="text-center">
            <Image src={havetoLogo} className="footer-logo-img" preview={false} />
            <div className="footer-text">
              First coin network to allow any programming
              <br />
              language and supports AI
            </div>
            <div className="features">
              <Row justify="space-between" gutter={[15, 15]}>
                <Col>
                  <div className="footer-text" style={{ textAlign: "center" }}>
                    Updates right to your inbox
                  </div>

                  <Space direction="vertical" size={12}>
                    <Input
                      type="text"
                      placeholder="Your email here"
                      className="footer-input"
                      onChange={(e)=>setemail(e.target.value)}/>
                    <Button className="footer-button" onClick={onSubscribe}>Subscribe</Button>
                  </Space>
                </Col>
                <Col>
                  <ul className="footer-menu">
                    <li>
                      <a href="#features">Features</a>
                    </li>
                    {/* <li>
                      <a href="#demo">Demo</a>
                    </li> */}
                    <li>
                      <a href="#roadmap">Roadmap</a>
                    </li>
                    <li>
                      <a href="#coin-table">Coin Table</a>
                    </li>
                    <li>
                      <a href="https://github.com/haveto/haveto-price-simulator" target="_blank">Tokenomics Simulator</a>
                    </li>
                    {/* <li>
                      <a href="#faq">FAQ</a>
                    </li> */}
                    <li>
                      <a href="#about">About</a>
                    </li>
                  </ul>
                </Col>
                <Col>
                <div onClick={handleDownloadWhitePaper} style={{ cursor: 'pointer' }}>
                  <Image
                    src={whitePaper}
                    preview={false}
                    className="white-paper"
                  />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <hr />
          <Row justify={"space-between"} align="bottom" gutter={[15, 15]}>
            <Col>
              <Space direction="horizontal">
                <Link to="/privacy-policy" className="footer-link">Privacy policy</Link>
              </Space>
            </Col>
            <Col className="footer-icon">
              <Space direction="horizontal" size={15}>
                <a href="https://x.com/haveto_com?t=KC4QKrSJsrb2XarYWGWmlQ&s=09" rel="noopener noreferrer" target="_blank">
                  <Image src={twitterIcon} alt="twitter" preview={false} />
                </a>
                <a href="https://www.linkedin.com/company/haveto-com/" rel="noopener noreferrer"  target="_blank">
                  <Image src={linkdinIcon} alt="linkedin" preview={false} />
                </a>
                <Dropdown overlay={menu}>
                  <a onClick={e => e.preventDefault()}>
                    <Space>
                      <Image src={telegramIcon} alt="telegram" preview={false} />
                    </Space>
                  </a>
                </Dropdown>
              </Space>
            </Col>
          </Row>
          <p className="copyright-text">
            &#169; {currentYear} HaveTo. All rights reserved
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;